import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const ResourcesDetailInlineCTAWrapper = styled.div`
  height: fit-content;
  max-width: 100%;

  display: flex;
  flex-direction: row;

  border-radius: 32px;
  background: #f7f7f7;

  border: 1px solid #f0f0f0;
  box-shadow: 0px 6px 24px 0px #0000001a;

  & > :not(:last-child) {
    margin-right: 24px;

    ${BREAKPOINTS.tablet} {
      margin-right: 16px;
    }
  }

  cursor: pointer;
`;

export const ResourcesDetailInlineCTAImageContainer = styled.div`
  width: 332px;
  height: 238px;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 32px 0px 0px 32px;

  overflow: hidden;

  ${BREAKPOINTS.tablet} {
    width: 106px;
    height: 106px;
  }

  background: #d9d9d9;
`;

export const ResourcesDetailInlineCTAIconContainer = styled.div`
  width: 106px;
  height: 106px;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 32px;

  ${BREAKPOINTS.tablet} {
    border-radius: 16px 0px 0px 16px;
  }

  background: var(--color-dark-theme-background-secondary);
`;

export const ResourcesDetailInlineCTAIcon = styled.img`
  width: 63px;
  height: 63px;

  object-fit: cover;
`;

export const ResourcesDetailInlineCTAImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ResourcesDetailInlineCTAContainer = styled.div`
  width: 468px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-around;
  gap: 6px;

  ${BREAKPOINTS.tablet} {
    width: 100%;
  }
`;

export const ResourcesDetailInlineCTARemoveIconContainer = styled.div`
  width: 18px;
  height: 18px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 100%;
  background: rgba(217, 217, 217, 0.5);

  cursor: pointer;
`;

export const ResourcesDetailInlineCTATitle = styled.h5`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.1em;
  text-align: left;

  text-transform: uppercase;

  color: #171c3380;
`;

export const ResourcesDetailInlineCTAName = styled.h4`
  font-weight: 400;
  font-size: 24px;
  line-height: 31px;
  letter-spacing: 0em;
  text-align: left;

  color: var(--color-text);

  ${BREAKPOINTS.tablet} {
    display: none;
  }
`;

export const ResourcesDetailInlineCTAURLContainer = styled.div`
  display: flex;
  align-items: center;

  & > :not(:last-child) {
    margin-right: 8px;
  }
  ${BREAKPOINTS.tablet} {
    display: none;
  }
`;

export const ResourcesDetailInlineCTAURLImage = styled.img`
  width: 16px;
  height: 16px;
`;

export const ResourcesDetailInlineCTAURL = styled.a`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;

  color: var(--color-primary);
`;
